import axios from 'axios';

export const BASE_URL = '/api/v1';

export const AUTH_HEADER = (authToken: string) => ({
    headers: {
        'X-Authorization': authToken,
    },
});

export const UPLOAD_HEADER = (authToken: string, fileType: string) => ({
    headers: {
        'X-Authorization': authToken,
        'Content-Type': fileType,
    },
});

export const apiClient = axios;